import { highArmorTokenProperty } from "../../property/resource/high-armor-token-property";
import { ResourceColumn } from "../planner-column";

export const highArmorTokenColumn = new ResourceColumn(
  'HA Tokens',
  'stl_item_76.png',
  'highArmorTokens',
  highArmorTokenProperty,
)
